<template>
    <div>
      <GoogleMap />
    </div>
</template>


<script>
import GoogleMap from "@/components/googleMap.vue";
  export default {
    name:'homeMap',
    data() {
      return {
        checked: true,
        referenceID: this.$route.params.referenceID,
      };
    },

  };
</script>

